export const ADMIN_ROLE = "admin";

export function isAdminRole(role?: string | null): boolean {
  return role === ADMIN_ROLE;
}

export function resolvePostAuthPath(user?: { role?: string | null } | null): string {
  return isAdminRole(user?.role) ? "/admin" : "/dashboard";
}
